export interface CustomerAssortment {
  name: string;
}

export interface UserCustomer {
  customerNumber: string;
  companyName: string;
  address1: string;
  address2: string;
  postalCode: string;
  city: string;
  paymentTerms: string;
  priceListTable: string;
  payer: string;
  customerType: string;
  status: string;
  currency: string;
  limeCustomerAssortments: CustomerAssortment;
  m3CustomerAssortments: CustomerAssortment;
  customerStop: string;
  customerGroup: string;
  warehouse: string;
}

export interface UserContact {
  roleCaps: string[];
  roleId: number;
  customerNumber: string;
  contactId: number;
  inactive: boolean;
}

export interface User {
  username?: string;
  user?: {
    id: string;
    firstName: string;
    lastName: string;
  };
  exp?: number;
  contacts?: UserContact[];
  customers?: UserCustomer[];
  isBendersEmployee?: boolean;
  country?: string;
  region?: string;
  actingAsUser?: boolean;
  allowedInProducts?: boolean;
  allowedInCQuotes?: boolean;
  accessibleAssortments?: string[];
  purchasableAssortments?: string[];
}

export interface Filter {
  corporation: string;
  representative: string;
  customer: string;
}

export interface Status {
  loggedIn: boolean;
  PRODUCT_API_ENABLE: boolean;
  acting_as_user: boolean;
}

export enum StoreType {
  user = 'user',
  filter = 'filter',
  region = 'region',
}
